import {Directive, HostBinding, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[appHighlightAmount]',
  standalone: true
})
export class HighlightAmountDirective implements OnInit {
  @HostBinding('style.color') color = 'black';
  @Input() value: string = 'black';

  ngOnInit() {
    this.color = this.setColor(Number(this.value));
  }

  private setColor(value: number): string {
    return value > 0 ? 'var(--color-attention-success)' : 'var(--color-primary-red)';
  }
}
